module.exports = __webpack_public_path__ + "static/media/delete.e7312762.svg";